import { BLACK_d } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 20rem;
  display: flex;
  flex-direction: column;
  gap: 6rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 10rem;
  }
`;

export const TextBox = styled.div`
  display: flex;
  width: 109.3rem;
  flex-direction: column;
  gap: 1rem;
  & > span:nth-child(1) {
    font-weight: 700;
    font-size: 5.2rem;
    line-height: 9.2rem;
  }
  & > span:nth-child(2) {
    font-weight: 300;
    font-size: 2.2rem;
    line-height: 3.8rem;
    color: ${BLACK_d};
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    & > span:nth-child(1) {
      font-size: 3.2rem;
      line-height: 5.4rem;
    }
    & > span:nth-child(2) {
      font-size: 1.8rem;
      line-height: 3.2rem;
      display: flex;
      flex-direction: column;
      gap: 3.2rem;
    }
  }
`;

export const ColorBox = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    gap: 1rem;
  }
`;

export const LongBox = styled.div`
  width: 59rem;
  height: 10rem;
  border-radius: 0.5rem;
  background: linear-gradient(90deg, #5c5ce5 0%, #34d2f1 38.54%, #71fa4c 73.44%, #f958d1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 2.4rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    height: 6rem;
  }
`;

export const ShortBox = styled.div`
  width: 28.5rem;
  height: 10rem;
  border-radius: 0.5rem;
  background-color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 2.4rem;

  color: ${(props) => (props.fontColor ? "black" : "#FFFFFF")};
  border: ${(props) => (props.border ? "1px solid #AAAAAA" : "")};
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: calc((100% - 1rem) / 2);
    height: 6rem;
  }
`;
